import { LayoutConst } from "core";
import styled from "styled-components";

export const MetricsMainContainer = styled.div`
    display: flex;
    width: 1152px;
    margin: 32px auto 0;
    flex-direction: column;
    padding: 0 16px;
    @media(max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        padding: 0 10px;
    }
`

export const MetricsPageTitle = styled.div`
    color: #151514;
    font-family: Inter;
    font-size: 43px;
    font-style: normal;
    font-weight: 600;
    line-height: 51px;
    letter-spacing: -0.86px;
    margin-bottom: 8px;

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 30px;
        line-height: 40px;
        letter-spacing: -0.6px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 20px;
        line-height: 26px;
        letter-spacing: -0.4px;
    }
`

export const MetricsPageSubtitle = styled.div`
    color: #909090;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.34px;
    a {
        text-decoration-line: underline;
        text-decoration-style: solid;
        color: inherit;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.26px;
    }

    svg {
        margin-left: 10px;
    }
`

export const MetricsPageContent = styled.div<any>`
    display: flex;
    gap: ${p => p.gap || 24}px;
    margin-top: 32px;
    flex-direction: ${p => p.direction || 'row'};

    .infinite-scroll-component {
        overflow: unset !important;
    }
    
    .infinite-scroll-component__outerdiv {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
        gap: 16px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-direction: column;
        gap: 48px;
    }
`

export const MetricsPageSetting = styled.div<any>`
    display: flex;
    flex-direction:  ${p => p.direction || 'column'};
    gap: 24px;
    width: ${p => p.width || '368px'};
    flex-shrink: 0;
    padding-bottom: ${p => p.offsetBottom || p.offsetBottom === 0 ? p.offsetBottom : '110px'};
    
    @media(max-width: ${LayoutConst.screen.l}px) {
        width:  ${p => p.direction || '225px'};
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        padding: 0;
    }
`

export const MetricsSettingsField = styled.div<any>`
    display: flex;
    flex-direction: ${p => p.direction || 'column'};
    gap: 8px;
    width: 100%;

    .radio-button--label {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        .radio-button--label {
            font-size: 13px;
            line-height: 16px;
            letter-spacing: -0.26px;
        }
    }
`

export const MetricsLabel = styled.div`
    color: #909090;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
    white-space: nowrap;

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.26px;
    }
`

export const MetricsSearch = styled.div`
    display: flex;
    gap: 12px;
    border-radius: 3px;
    background: #F2F2F2;
    padding: 14px 16px;
    align-items: center;
    position: relative;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.3px;
    
    input {
        background: transparent;
        border: none;
        outline: none;
        padding: 0;
        width: 100%;
        
        ::placeholder {
            color: #BFBFBF;
        }
    }

    svg {
        height: 16px;
        width: 16px;
        &.clear-icon {
            cursor: pointer;
        }
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: 0.26px;
        padding: 12px 16px;
    }
`

export const MetricsSearchList = styled.div<{openToUp?: boolean}>`
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    width: 100%;
    ${p => p.openToUp? 'bottom' : 'top'}: 100%;
    z-index: 1;
    font-size: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    gap: 8px;
    & > div {
        width: 100%;
    }
    max-height: calc(52px * 4);
    background: #F2F2F2 !important;
    overflow-y: scroll;
    &::-webkit-scrollbar {
        width: 4px !important;
    }
    &::-webkit-scrollbar-track {
        background: #E7E7E7 !important;
        width: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: #B6B6B5 !important;
        border-radius: 2px;
        width: 4px;
        height: 96px;
    }

    .black-tag-item {
        &, & div {
            font-size: inherit;
            line-height: inherit;
            letter-spacing: inherit;
            color: #909090;
        }
        padding: 8px 16px;
    }

`

export const MetricsAvatarContainer = styled.div`
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    display: flex;

    div {
        border-radius: 3px;
    }
`

export const MetricsPageTableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    .winner {
        background: #F2FFE8;
    }

    .short-list {
        background: #FFF6EF;
    }

    .bold {
        td {
            font-weight: 600;
        }
        font-weight: 600;
    }
`

export const MetricsTableLegend = styled.div`
    display: flex;
    gap: 24px;
    margin-bottom: 12px;
    align-items: center;
    color: var(--Gallllery-Black47, #909090);
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.26px;

    & > div {
        display: flex;
        align-items: center;
        gap: 0.33em;
    }

    .winner,
    .short-list {
        border: 0.8px solid #E7E7E7;
        border-radius: 3px;
        width: 16px;
        height: 16px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-wrap: wrap;
        row-gap: 8px;
        & > div:first-of-type {
            width: 100%;
        }
    }
`

export const MetricsPageTable = styled.table`
    overflow-x: initial;
    &.table-scrollable {
        overflow-x: auto;
        max-width: 100%;
        td {
            text-align: center;
        }
    }

    &.metrics_teachers-table {
        display: inline-block;
        th {
            height: 129px;
            // height: 68px;
        }
        td {
            height: 32px;
        }
    }

    th, td {
        padding: 8px;
        color: #151514;
        font-family: Inter;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: -0.26px;
        border: 1px solid #E7E7E7;
    }

    tr.empty-row {
        border: none;
        height: 16px !important;
    }

    th {
        background: #F2F2F2;
        :first-child {
            text-align: center;
        }
    }

    td {
        :first-of-type,
        :last-of-type {
            text-align: center;
        }
        height: 32px;
        &.metrics_name-cell {
            min-width: 280px;
            text-align: left;
        }
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
        td  {
            &.metrics_name-cell {
                min-width: 158px;
            }
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        th, td {
            font-size: 11px;
            line-height: 13px;
            &.metrics_name-cell {
                min-width: 94px;
            }
        }
    }

    .tippy-box {
        max-width: 360px !important;
    }
`

export const MetricsTableTooltip = styled.div`
    display: flex;
    flex-direction: column;
    padding: 4px 8px;
    color: #70706F;
    font-family: Inter;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 13px;
    border-radius: 6px;
    background: #E7E7E7;
    gap: 4px;
`import { LayoutConst } from "core";
import styled from "styled-components";

export const MetricsMainContainer = styled.div`
    display: flex;
    width: 1152px;
    margin: 32px auto 0;
    flex-direction: column;
    padding: 0 16px;
    @media(max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        padding: 0 10px;
    }
`

export const MetricsPageTitle = styled.div`
    color: #151514;
    font-family: Inter;
    font-size: 43px;
    font-style: normal;
    font-weight: 600;
    line-height: 51px;
    letter-spacing: -0.86px;
    margin-bottom: 8px;

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 30px;
        line-height: 40px;
        letter-spacing: -0.6px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 20px;
        line-height: 26px;
        letter-spacing: -0.4px;
    }
`

export const MetricsPageSubtitle = styled.div`
    color: #909090;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.34px;
    a {
        text-decoration-line: underline;
        text-decoration-style: solid;
        color: inherit;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.26px;
    }

    svg {
        margin-left: 10px;
    }
`

export const MetricsPageContent = styled.div<any>`
    display: flex;
    gap: ${p => p.gap || 24}px;
    margin-top: 32px;
    flex-direction: ${p => p.direction || 'row'};

    .infinite-scroll-component {
        overflow: unset !important;
    }
    
    .infinite-scroll-component__outerdiv {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
        gap: 16px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-direction: column;
        gap: 48px;
    }
`

export const MetricsPageSetting = styled.div<any>`
    display: flex;
    flex-direction:  ${p => p.direction || 'column'};
    gap: 24px;
    width: ${p => p.width || '368px'};
    flex-shrink: 0;
    padding-bottom: ${p => p.offsetBottom || p.offsetBottom === 0 ? p.offsetBottom : '110px'};
    
    @media(max-width: ${LayoutConst.screen.l}px) {
        width:  ${p => p.direction || '225px'};
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        padding: 0;
    }
`

export const MetricsSettingsField = styled.div<any>`
    display: flex;
    flex-direction: ${p => p.direction || 'column'};
    gap: 8px;
    width: 100%;

    .radio-button--label {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        .radio-button--label {
            font-size: 13px;
            line-height: 16px;
            letter-spacing: -0.26px;
        }
    }
`

export const MetricsLabel = styled.div`
    color: #909090;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
    white-space: nowrap;

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.26px;
    }
`

export const MetricsSearch = styled.div`
    display: flex;
    gap: 12px;
    border-radius: 3px;
    background: #F2F2F2;
    padding: 14px 16px;
    align-items: center;
    position: relative;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.3px;
    
    input {
        background: transparent;
        border: none;
        outline: none;
        padding: 0;
        width: 100%;
        
        ::placeholder {
            color: #BFBFBF;
        }
    }

    svg {
        height: 16px;
        width: 16px;
        &.clear-icon {
            cursor: pointer;
        }
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: 0.26px;
        padding: 12px 16px;
    }
`

export const MetricsSearchList = styled.div<{openToUp?: boolean}>`
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    width: 100%;
    ${p => p.openToUp? 'bottom' : 'top'}: 100%;
    z-index: 1;
    font-size: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    gap: 8px;
    & > div {
        width: 100%;
    }
    max-height: calc(52px * 4);
    background: #F2F2F2 !important;
    overflow-y: scroll;
    &::-webkit-scrollbar {
        width: 4px !important;
    }
    &::-webkit-scrollbar-track {
        background: #E7E7E7 !important;
        width: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: #B6B6B5 !important;
        border-radius: 2px;
        width: 4px;
        height: 96px;
    }

    .black-tag-item {
        &, & div {
            font-size: inherit;
            line-height: inherit;
            letter-spacing: inherit;
            color: #909090;
        }
        padding: 8px 16px;
    }

`

export const MetricsAvatarContainer = styled.div`
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    display: flex;

    div {
        border-radius: 3px;
    }
`

export const MetricsPageTableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    .winner {
        background: #F2FFE8;
    }

    .short-list {
        background: #FFF6EF;
    }

    .bold {
        td {
            font-weight: 600;
        }
        font-weight: 600;
    }
`

export const MetricsTableLegend = styled.div`
    display: flex;
    gap: 24px;
    margin-bottom: 12px;
    align-items: center;
    color: var(--Gallllery-Black47, #909090);
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.26px;

    & > div {
        display: flex;
        align-items: center;
        gap: 0.33em;
    }

    .winner,
    .short-list {
        border: 0.8px solid #E7E7E7;
        border-radius: 3px;
        width: 16px;
        height: 16px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-wrap: wrap;
        row-gap: 8px;
        & > div:first-of-type {
            width: 100%;
        }
    }
`

export const MetricsPageTable = styled.table`
    overflow-x: initial;
    &.table-scrollable {
        overflow-x: auto;
        max-width: 100%;
        td {
            text-align: center;
        }
    }

    &.metrics_teachers-table {
        display: inline-block;
        th {
            height: 129px;
            // height: 68px;
        }
        td {
            height: 32px;
        }
    }

    th, td {
        padding: 8px;
        color: #151514;
        font-family: Inter;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: -0.26px;
        border: 1px solid #E7E7E7;
    }

    tr.empty-row {
        border: none;
        height: 16px !important;
    }

    th {
        background: #F2F2F2;
        :first-child {
            text-align: center;
        }
    }

    td {
        :first-of-type,
        :last-of-type {
            text-align: center;
        }
        height: 32px;
        &.metrics_name-cell {
            min-width: 280px;
            text-align: left;
        }
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
        td  {
            &.metrics_name-cell {
                min-width: 158px;
            }
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        th, td {
            font-size: 11px;
            line-height: 13px;
            &.metrics_name-cell {
                min-width: 94px;
            }
        }
    }

    .tippy-box {
        max-width: 360px !important;
    }
`

export const MetricsTableTooltip = styled.div`
    display: flex;
    flex-direction: column;
    padding: 4px 8px;
    color: #70706F;
    font-family: Inter;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 13px;
    border-radius: 6px;
    background: #E7E7E7;
    gap: 4px;
`